import React from 'react'
import PropTypes from 'prop-types'

const LandingPreview = (props) => {
  const { entry, widgetFor, widgetsFor } = props
  const slug = entry.getIn(['data', 'title'])
  const landingUrl = entry.getIn(['data', 'landingUrl'])
  const date = entry.getIn(['data', 'date'])
  const description = entry.getIn(['data', 'shortDescription'])
  const tags = entry.getIn(['data', 'tags'])
  const landingType = entry.getIn(['data', 'landingType'])
  const pageType = entry.getIn(['data', 'pageType'])
  const body = widgetFor('body')
  const sections = widgetsFor('sections')

  return (
    <div>
      <div>{body}</div>
      {sections &&
        sections.map((section, i) => {
          if (!section) return null
          const value = section.getIn(['data', 'value'])
          if (!value) return null
          let className

          if (i % 2 === 0) {
            className = 'lpage-section-blue'
          } else {
            className = 'lpage-section-white'
          }

          return (
            <div className={className} key={`lpageSection_${i}`}>
              <div className="lpage-content">{value}</div>
            </div>
          )
        })}
    </div>
  )
}

LandingPreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  widgetFor: PropTypes.func,
}

export default LandingPreview



// WEBPACK FOOTER //
// ./src/cms/previews/Landing.js